import { baseApi } from './baseApi';

/**
 * Manufacturers API endpoints
 * Handles CRUD operations for manufacturer management
 */
export const manufacturersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /manufacturers - Fetch all manufacturers
    getManufacturers: builder.query({
      query: () => '/manufacturers',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ manufacturer_id }) => ({ type: 'Manufacturer', id: manufacturer_id })),
              { type: 'Manufacturer', id: 'LIST' },
            ]
          : [{ type: 'Manufacturer', id: 'LIST' }],
    }),

    // GET /manufacturers/:id - Fetch manufacturer by ID
    getManufacturerById: builder.query({
      query: (id) => `/manufacturers/${id}`,
      providesTags: (result, error, id) => [{ type: 'Manufacturer', id }],
    }),

    // POST /manufacturers - Create new manufacturer
    createManufacturer: builder.mutation({
      query: (manufacturerData) => ({
        url: '/manufacturers',
        method: 'POST',
        body: manufacturerData,
      }),
      invalidatesTags: [{ type: 'Manufacturer', id: 'LIST' }],
    }),

    // PATCH /manufacturers/:id - Update manufacturer
    updateManufacturer: builder.mutation({
      query: ({ id, ...manufacturerData }) => ({
        url: `/manufacturers/${id}`,
        method: 'PATCH',
        body: manufacturerData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Manufacturer', id },
        { type: 'Manufacturer', id: 'LIST' },
      ],
    }),

    // DELETE /manufacturers/:id - Delete manufacturer
    deleteManufacturer: builder.mutation({
      query: (id) => ({
        url: `/manufacturers/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Manufacturer', id },
        { type: 'Manufacturer', id: 'LIST' },
      ],
    }),

    // GET /manufacturers/:id/metadata - Get manufacturer metadata
    getManufacturerMetadata: builder.query({
      query: (id) => `/manufacturers/${id}/metadata`,
      providesTags: (result, error, id) => [{ type: 'ManufacturerMetadata', id }],
    }),

    // POST /manufacturers/:id/metadata - Add manufacturer metadata
    addManufacturerMetadata: builder.mutation({
      query: ({ id, metadata }) => ({
        url: `/manufacturers/${id}/metadata`,
        method: 'POST',
        body: metadata,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'ManufacturerMetadata', id },
        { type: 'Manufacturer', id },
      ],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetManufacturersQuery,
  useGetManufacturerByIdQuery,
  useCreateManufacturerMutation,
  useUpdateManufacturerMutation,
  useDeleteManufacturerMutation,
  useGetManufacturerMetadataQuery,
  useAddManufacturerMetadataMutation,
} = manufacturersApi;

